// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .average .mat-slider-thumb {
  background-color: #ff3967;
}

:host ::ng-deep .min .mat-slider-thumb {
  background-color: blue;
}

:host ::ng-deep .min .mat-slider-thumb-label {
  background-color: blue;
}

:host ::ng-deep .min .mat-slider-track-fill {
  background-color: blue;
}

:host ::ng-deep .max .mat-slider-thumb {
  background-color: orange;
}

:host ::ng-deep .max .mat-slider-thumb-label {
  background-color: orange;
}

:host ::ng-deep .max .mat-slider-track-fill {
  background-color: orange;
}
`, "",{"version":3,"sources":["webpack://./src/app/all/all-child.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[":host ::ng-deep .average .mat-slider-thumb {\n  background-color: #ff3967;\n}\n\n:host ::ng-deep .min .mat-slider-thumb {\n  background-color: blue;\n}\n\n:host ::ng-deep .min .mat-slider-thumb-label {\n  background-color: blue;\n}\n\n:host ::ng-deep .min .mat-slider-track-fill {\n  background-color: blue;\n}\n\n:host ::ng-deep .max .mat-slider-thumb {\n  background-color: orange;\n}\n\n:host ::ng-deep .max .mat-slider-thumb-label {\n  background-color: orange;\n}\n\n:host ::ng-deep .max .mat-slider-track-fill {\n  background-color: orange;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
